// extracted by mini-css-extract-plugin
export default {"table":"styles_table__X-0dI","buttonWrapper":"styles_buttonWrapper__zMPOE","deleteIcon":"styles_deleteIcon__BP41K","sessionTime":"styles_sessionTime__KaneW"};